module.exports = __webpack_public_path__ + "img/visa.70633ce7.svg";